export default __webpack_public_path__ + "static/media/complete-04.691d031a.png";